jQuery.noConflict();

var initAutocomplete, geolocate;
var placeSearch, autocomplete;
(function($, window) {
    var adjustAnchor = function() {

        var $anchor = $(':target'),
            fixedElementHeight = 300;

        if ($anchor.length > 0) {

            $('html, body')
                .stop()
                .animate({
                    scrollTop: $anchor.offset().top - fixedElementHeight
                }, 200);

        }

    };

    $(window).on('hashchange load', function(e) {
        e.preventDefault();
        adjustAnchor();
    });

})(jQuery, window);
(function($) {

    /* * * * * * * * * * * * * * * * * *
* Show/hide fields conditionally
* * * * * * * * * * * * * * * * * */
    (function($) {
        $.fn.conditionize = function(options){

            var settings = $.extend({
                hideJS: true
            }, options );

            $.fn.showOrHide = function(listenTo, listenFor, $section) {

                if ($(listenTo).is('select, input[type=text]') && $(listenTo).val() == listenFor) {
                    $section.slideDown();
                    $($section).find('.form-control, .form-check-input').prop("disabled", false);

                } else if ($(listenTo + ":checked").val() == listenFor) {
                    $section.slideDown();
                    console.log($(listenTo).find('.form-control'));
                    $($section).find('.form-control, .form-check-input').prop("disabled", false);
                } else {
                    $section.slideUp();
                    $($section).find('.form-control, .form-check-input').prop("disabled", true);
                }
            };

            return this.each( function() {
                var listenTo = "." + $(this).data('cond-option');
                var listenFor = $(this).data('cond-value');
                var $section = $(this);

                //Set up event listener
                $(listenTo).on('change', function() {
                    $.fn.showOrHide(listenTo, listenFor, $section);
                });
                //If setting was chosen, hide everything first...
                if (settings.hideJS) {
                    $(this).hide();
                }
                //Show based on current value on page load
                $.fn.showOrHide(listenTo, listenFor, $section);
            });
        }
    }(jQuery));

    $('.conditional').conditionize();


    $(document).ready(function(){

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

        $(".gallery-icon a").fancybox();

        (function () {
            $('.book-strategy-wrapper .btn, .book-strategy-cta').on('click', function (e) {
                e.preventDefault();
                $('#contact-modal').modal();
            })
        })();

        $(document).on('click', '#wrapper-navbar .dropdown-menu', function (e) {
            e.stopPropagation();
        });

        $(function () {
            $('[data-toggle="popover"]').popover({
                trigger: 'click'
            });

            $('body').on('click', function (e) {
                $('[data-toggle=popover]').each(function () {
                    // hide any open popovers when the anywhere else in the body is clicked
                    if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                        $(this).popover('hide');
                    }
                });
            });
        });

        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }


        (function () {
            $('#sms-verification').on('click', function(e) {
                e.preventDefault();
                let $that = $(this);
                let phone = $that.attr('data-phone');

                let data = {
                    'phone': phone,
                };

                $that.addClass('disabled');

                ajaxHelper(data, 'send_auth_code').then((response) => {
                    console.log(response);
                    $that.removeClass('disabled');
                }, (response) => {
                    console.log(response);
                });
            });
        })();


        (function () {
            $('#subscribe-form').on('submit', function(e) {
                e.preventDefault();
                let $that = $(this),
                    $noticeWrapper = $that.find('.newsletter-msg'),
                    $honey = $that.find('#b_31c7ce87dd149729f78dbb99e_ad09da451d');

                if ($honey.val() || !$that.find('#EMAIL').val()) {
                    return false;
                }

                let data = {
                    'email': $that.find('#EMAIL').val(),
                };


                ajaxHelper(data, 'newsletter_signup').then((response) => {
                    // console.log(response);
                    $noticeWrapper.html(response.msg);
                    // $that.removeClass('disabled');
                }, (response) => {
                    console.log(response);
                });
            });
        })();


        (function () {
            $('#datum_rojstva_holder').on('change', function () {
                let $form = $('#konfigurator-form');
                var $section = $('.legal-age-conditional');

                let date = $(this).val();

                let dateFormatted = moment(date, "dd.mm.YYYY").format('YYYY'),
                    today = moment().format('YYYY');

                let diff = today - dateFormatted;

                if (diff > 17) {
                    $form.attr('action', '?step=3');
                    $section.show();
                    $section.find('.form-control, .form-check-input').prop("disabled", false);
                } else {
                    $form.attr('action', '?step=2');
                    $section.hide();
                    $section.find('.form-control, .form-check-input').prop("disabled", true);
                }

            });
        })();

        (function() {
            const $ponudnikiMap = $('#ponudniki-map');

            if($ponudnikiMap.length > 0) {
                window.ponudnikiMap = new GMaps({
                    div: '#ponudniki-map',
                    lat: 46.0569,
                    lng: 14.5058,
                    zoom: isMobile ? 8 : 9
                });

                if (typeof ponudniki !== 'undefined') {
                    drawMarketsOnMap(ponudniki);

                }
            }


        })();

        $('#open-ponudniki-search').on('click', function (e) {
            e.preventDefault();

            $(this).hide();

            $('#iskalnik-wrapper').show();
        });

        function drawMarketsOnMap(ponudniki) {
            if (!ponudniki) {
                return false;
            }



            ponudniki.forEach(function(ponudnik) {
                // console.log(ponudnik.location.lat);
                if(ponudnik.location.lat && ponudnik.location.lng) {
                    window.ponudnikiMap.addMarker({
                        lat: ponudnik.location.lat,
                        lng: ponudnik.location.lng,
                        title: ponudnik.name,

                        details: {
                            'ponudnikId': ponudnik.id
                        },
                        infoWindow: {
                            content: '<div class="d-flex flex-column" data-test="2"><span class="location-title mb-2">' + ponudnik.name + '</span><span class="location-address">' + ponudnik.location.address + '</span> <span class="d-block">'+ponudnik.phone + '</span> <span class="d-block"> ' + ponudnik.email +'</span></div>',
                            zIndex: -1
                        },

                        mouseover: function () {
                            this.setZIndex(10);
                            // $(this).parent().hide();
                        },
                        mouseout: function () {
                            this.setZIndex(1);
                        },
                    });
                }

            });
        }
        var formatContent = function () {
            return 'yay';
        };

        $('.kombinacija-cost.empty').on('click', function (e) {
            e.preventDefault();
            let $that = $(this);

            $('#age-modal').modal('show');
        });

        $('#age-form-ajax').on('submit', function (e) {
            e.preventDefault();
        }).on('change', function (e) {
            e.preventDefault();

            let age = $('#age-ajax').val();

            let data = {
                'age': age,
            };

            ajaxHelper(data, 'set_age_ajax').then((response) => {
                location.reload();
            }, (response) => {

            });
        });

        $('#pogoji_sklenitve').on('change', function() {
            console.log('change');
            $('#konf-submit-btn').prop('disabled', !$('#pogoji_sklenitve').is(':checked'));
        });

        function get_bank_details(trr) {
            if (!trr) {
                return false;
            }

            const banke = {
                '05': {
                    'naziv': 'ABANKA VIPA d.d.',
                    'bic': 'ABANSI2XXXX'
                },
                '33': {
                    'naziv': 'ADDIKO BANK D.D.',
                    'bic': 'HAABSI22XXX'
                },
                '10': {
                    'naziv': 'BANKA INTESA SANPAOLO d.d.',
                    'bic': 'BAKOSI2XXXX'
                },
                '01': {
                    'naziv': 'BANKA SLOVENIJE',
                    'bic': 'BSLJSI2XXXX'
                },
                '34': {
                    'naziv': 'BANKA SPARKASSE D.D.',
                    'bic': 'BSLJSI2XXXX'
                },
                '35': {
                    'naziv': 'BKS BANK AG, podružnica Ljubljana',
                    'bic': 'BFKKSI22XXX'
                },
                '61': {
                    'naziv': 'DELAVSKA HRANILNICA D.D.',
                    'bic': 'HDELSI22XXX'
                },
                '19': {
                    'naziv': 'DEŽELNA BANKA SLOVENIJE d.d.',
                    'bic': 'SZKBSI2XXXX'
                },
                '07': {
                    'naziv': 'GORENJSKA BANKA d.d.',
                    'bic': 'GORESI2XXXX'
                },
                '60': {
                    'naziv': 'HRANILNICA LON d.d.',
                    'bic': 'HLONSI22XXX'
                },
                '04': {
                    'naziv': 'NOVA KREDITNA BANKA MARIBOR d.d.',
                    'bic': 'KBMASI2XXXX'
                },
                '02': {
                    'naziv': 'NOVA LJUBLJANSKA BANKA d.d.',
                    'bic': 'LJBASI2XXXX'
                },
                '64': {
                    'naziv': 'PRIMORSKA HRANILNICA VIPAVA d.d.',
                    'bic': 'HKVISI22XXX'
                },
                '30': {
                    'naziv': 'SBERBANK BANKA d.d.',
                    'bic': 'SABRSI2XXXX'
                },
                '03': {
                    'naziv': 'SKB BANKA d.d.',
                    'bic': 'SKBASI2XXXX'
                },
                '29': {
                    'naziv': 'UNICREDIT BANKA SLOVENIJE D.D.',
                    'bic': 'BACXSI22XXX'
                },
            };

            let trrStr = trr.toString();

            trrStr = trrStr.replace(/\s/g, '');
            trrStr = trrStr.substr(4);

            let bankCode = trrStr.slice(0, 2);

            return banke[bankCode];
        }

        $('#Iban').mask('SS00 0000 0000 0000 000');
        $('#payer-phone, #holder-phone').mask('000000000');

        $('#Iban').on('change', function () {
            let val = $(this).val();
            let bankDetails = get_bank_details($(this).val()),
                $noticeWrapper = $(this).siblings('.notice-wrapper');

            if (!RE.util.Validators.isValidIBAN(val)) {
                $noticeWrapper.html('Številka računa ni pravilna, ali ste vnesli številko računa čigar banke ne podpiramo.');
                return;
            }


            if (bankDetails) {
                $('#Bic').val(bankDetails.bic);
                $('#BankName').val(bankDetails.naziv);

                $('#Bic').siblings('.sr-only').addClass('has-value');
                $('#BankName').siblings('.sr-only').addClass('has-value');

                $noticeWrapper.html('');
            } else {
                $noticeWrapper.html('Številka računa ni pravilna, ali ste vnesli številko računa čigar banke ne podpiramo.');
                $(this).val('');
                $('#Bic').val('');
                $('#BankName').val('');

                $('#Bic').siblings('.sr-only').removeClass('has-value');
                $('#BankName').siblings('.sr-only').removeClass('has-value');
            }
        });


        $('.trigger-phone').on('click', function () {
            let $that = $(this);
            let phone = $that.attr('data-phone');

            let data = {
                'phone': phone,
            };

            ajaxHelper(data, 'send_auth_code').then((response) => {

            }, (response) => {

            });
        });

        //validations
        (function () {
            const $submit = $('#konf-submit-btn');
            const $zzzs = $('#zzzs');
            const $ds = $('#davcna_st');
            const $starost = $('#datum_rojstva_holder');

            $ds.on('change', function () {
                let $noticeWrapper = $(this).siblings('.notice-wrapper');

                if (validateTax($ds)) {
                    if (validateZZZS($zzzs)) {
                        $submit.attr('disabled', false);
                    }
                    $noticeWrapper.html('');
                } else {
                    $submit.attr('disabled', 'disabled');
                    $noticeWrapper.html('Davčna številka ni pravilna');
                }
            });

            $zzzs.mask('000000000');
            $zzzs.on('change', function () {
                let $noticeWrapper = $(this).siblings('.notice-wrapper');

                if (validateZZZS($zzzs)) {
                    if (validateTax($ds)) {
                        $submit.attr('disabled', false);
                    }
                    $noticeWrapper.html('');
                } else {
                    $submit.attr('disabled', 'disabled');
                    $noticeWrapper.html('Številka zdravstvenega zavarovanja ni pravilna');
                }
            });

            $starost.on('change', function() {console.log('change');
                let $noticeWrapper = $(this).siblings('.notice-wrapper');

                let $minAge = $(this).data('min-age');
                let $maxAge = $(this).data('max-age');

                let $age = getAge($starost.val());

                if (!validateAge($starost)) {
                    $submit.attr('disabled', 'disabled');
                    $noticeWrapper.html('Pristopna starost zavarovanca mora biti večja ali enaka 1 in manjša ali enaka 68 let.');
                } else if ($age > $maxAge || $age < $minAge) {
                    $submit.attr('disabled', 'disabled');
                    $noticeWrapper.html('Starost ne ustreza izbrani starostni skupini.');
                } else {
                    $submit.attr('disabled', false);
                    $noticeWrapper.html('');
                }

                /* if (validateAge($starost)) {
                    $submit.attr('disabled', false);
                    $noticeWrapper.html('');
                } else {
                    $submit.attr('disabled', 'disabled');
                    $noticeWrapper.html('Pristopna starost zavarovanca mora biti večja ali enaka 1 in manjša ali enaka 68 let.');
                } */
            });

            $starost.on('keyup', function() {
                if (/^[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{4}$/.test($starost.val())) {
                    let $noticeWrapper = $(this).siblings('.notice-wrapper');

                    let $minAge = $(this).data('min-age');
                    let $maxAge = $(this).data('max-age');

                    let $age = getAge($starost.val());

                    if (!validateAge($starost)) {
                        $submit.attr('disabled', 'disabled');
                        $noticeWrapper.html('Pristopna starost zavarovanca mora biti večja ali enaka 1 in manjša ali enaka 68 let.');
                    } else if ($age > $maxAge || $age < $minAge) {
                        $submit.attr('disabled', 'disabled');
                        $noticeWrapper.html('Starost ne ustreza izbrani starostni skupini.');
                    } else {
                        $submit.attr('disabled', false);
                        $noticeWrapper.html('');
                    }

                    /* if (validateAge($starost)) {
                        $submit.attr('disabled', false);
                        $noticeWrapper.html('');
                    } else {
                        $submit.attr('disabled', 'disabled');
                        $noticeWrapper.html('Pristopna starost zavarovanca mora biti večja ali enaka 1 in manjša ali enaka 68 let.');
                    } */
                }
            });
        })();

        function validateAge($item) {
            let age = getAge($item.val());

            return !isNaN(age) && age >= 1 && age <= 68;
        }

        function getAge(dateString) {
            [ d, m, y ] = dateString.split('.')

            let birthDate = Date.parse(y, m, d);
            let ageDifMs = Date.now() - birthDate;
            let ageDate = new Date(ageDifMs);

            return Math.abs(ageDate.getUTCFullYear() - 1970);
        }


        function validateTax($item) {
            return RE.util.Validators.isValidTaxNumber($item.val());
        }

        function validateZZZS($item) {
            return RE.util.Validators.isValidNumberModul11($item.val(),9);
        }

        $('#konfigurator-form-complete').on('submit', function (e) {
            e.preventDefault();
            const $that = $(this);

            let $noticeWrapper = $('#verification_code').siblings('.notice-wrapper'),
                $submitModal = $('#config-submit-modal');

            let data = {
                'code': $that.find('#verification_code').val()
            };

            ajaxHelper(data, 'verify_confirmation_code').then((response) => {
                if (response.success === true) {
                    $noticeWrapper.hide();
                    //If auth code is correct, proceed to submitting the form
                    $submitModal.modal({
                        backdrop: 'static',
                        keyboard: false
                    });

                    ajaxHelper(data, 'submit_conf_form').then((response) => {
                        
                        if (response.success === true) {
                            $submitModal.find('.waiting').hide();
                            $submitModal.find('.done').show();
                            //If auth code is correct, proceed to submitting the form
                        } else {

                        }
                    }, (response) => {
                        console.log(response);
                    });
                } else {
                    console.log('Auth code incorrect');
                    $noticeWrapper.show();
                }
            }, (response) => {
                console.log(response);
            });
        });

        (function () {

            let $dateField = $('.datefield');

            if($dateField.length > 0) {

                let options = {
                    dateFormat: "d.m.Y",
                    locale: 'sl',
                    allowInput:true,
                    // altInput: true,
                    // altFormat,
                    // allowInput: true,
                };


                const f = $dateField.flatpickr(options);
                // f._input.onkeypress = () => false;


                if (isMobile) {
                    $dateField.on('change', function () {
                        
                        let $fields = $(this).closest('.form-group').find('.datefield');
                        if ($(this).val()) {
                        
                            $fields.addClass('has-val');
                        } else {
                        
                            $fields.removeClass('has-val');
                        }
                    });
                }
            }



        })();


        var acceptableArr = [];





        //Paket select
        (function () {
            let $card = $('.paket-card:not(.elementor-table-item)'),
                $izbiraWrapper = $('#izbira-zavarovanja-wrapper');

            $card.on('click', function (e) {
               e.preventDefault();

               let $that = $(this),
                   $kritje = $that.closest('.kritje'),
                   $selectControl = $kritje.find('.kritje-select-control'),
                   $selectedPaketWrapper = $kritje.find('.selected-paket-wrapper'); //Wrapper where the selected "paket" name should be placed


                //Trying to unselect an item that potentially needs to be selected
                if ($that.hasClass('selected') && acceptableArr.length > 0) {

                    let thatParent = $that.data('parent');


                    if (!$('.linked-item').hasClass('selected')) {
                        acceptableArr = [];
                    }

                    if (acceptableArr.includes(thatParent)) {
                        return;
                    }
                }

                if ($that.data('linked')) {

                    if ($that.hasClass('selected')) {
                        //If specialisti is unchecked, remove all requirements
                        acceptableArr = [];
                    } else {
                        let linkedArr = $that.data('linked').split(',');

                        for (const item of linkedArr) {
                            let [package, key] = item.split(':');

                            let $t = $('.paket-card[data-key="'+key+'"][data-parent="' + package +  '"]');
                            acceptableArr.push($t.data('parent'));

                            // $t.siblings().each(() => {
                            //     acceptableArr.push($(this).data('parent'));
                            // });

                            if (!$t.hasClass('selected')) {
                                $t.click();
                            }
                            $t.closest('.kritje-collapsible').collapse('show');
                        }

                        if (
                            $that.data('key') === 'nadstandard' && 
                            $that.data('parent') === 'PackageSpecialist' &&
                            window.sessionStorage.getItem('nadstandardPopupShow') === null
                        ) {
                            showNadstandardPopup(
                                localize.texts.nadstandard_popup_izbira.zgornje_besedilo,
                                localize.texts.nadstandard_popup_izbira.spodnje_besedilo
                            );

                            window.sessionStorage.setItem('nadstandardPopupShow', true);
                        }
                    }
                }

                if (
                    $that.data('key') === 'nadstandard' && 
                    $that.data('parent') === 'PackageSpecialist' &&
                    $that.hasClass('selected')
                ) {
                    if (!$('[data-parent="PreventiveCheckup"][data-key="1"]').hasClass('selected')) {
                        $('[data-parent="PreventiveCheckup"][data-key="1"]').click();
                    }
                }

                if (
                    $that.data('key') === 'standard' &&
                    $that.data('parent') === 'PackageSpecialist'
                ) {                    
                    $('[data-parent="PreventiveCheckup"][data-key="1"]').removeClass('selected')

                    jQuery('[name="kritja[PreventiveCheckup]"]').removeAttr('value')
                }

                // else {
                //     console.log('is not linked');
                //     $that.siblings().each(() => {
                //         console.log($(this).data('linked'));
                //         // console.log('yaay');
                //         // if (!$(this).data('linked')) {
                //         //     acceptableArr = [];
                //         // }
                //     });
                //
                //
                //
                // }



                //Basic styling (red on selected)
               $kritje.find('.paket-card').not(this).removeClass('selected');
               $that.toggleClass('selected');


               let selectedPackage = $that.attr('data-key'),
                    kritjeKey = $that.attr('data-parent');

               if ($selectControl.val() === selectedPackage) {
                   $selectControl.val('');
               } else {
                   $selectControl.val(selectedPackage);
               }


               let selectedHelper = $selectControl.val();

                //Triggers a custom event whenever a "paket" is selected
                $izbiraWrapper.trigger('custom', [kritjeKey, selectedHelper]);


               let paketName = $('.paket-card[data-key="'+ selectedHelper + '"]').find('.paket-title').html();



                $selectedPaketWrapper.html(paketName);


               let activeKritja = $izbiraWrapper.data('selected-kritja');

               if (activeKritja !== undefined) {

                   if (activeKritja.length > 0) {
                       $izbiraWrapper.addClass('has-selection');
                   } else {
                       $izbiraWrapper.removeClass('has-selection');
                   }

                   $('.kritje').removeClass('is-selected');

                   activeKritja.forEach(activeKritje => {
                       // console.log(activeKritje);
                       $('#'+activeKritje).closest('.kritje').addClass('is-selected');
                   });
               }

                $izbiraWrapper.trigger('custom', [kritjeKey, selectedHelper]);

                // let shouldClear = true;
                // // console.log('should go first');
                // $('.linked-item').each(function() {
                //     // console.log('iterate');
                //     if ($(this).hasClass('selected')) {
                //         console.log('should clear');
                //         shouldClear = false;
                //         // var class_name = $(this).attr('class');
                //         // do something
                //     }
                // });
                //
                // setTimeout(function(){
                //     console.log('test:', shouldClear);
                // }, 200);
                // console.log('should go last');
                // if (shouldClear) {
                //     acceptableArr = [];
                // }


                let showGeneplanetQuestion = 
                    (jQuery('[data-parent="PackageSpecialist"][data-key="standard"]').hasClass('selected') && jQuery('[data-parent="PackageIntervention"][data-key="intervention_medium"]').hasClass('selected') && jQuery('[data-parent="PackageRehab"][data-key="1"]').hasClass('selected')) ||
                    (jQuery('[data-parent="PackageSpecialist"][data-key="standard"]').hasClass('selected') && jQuery('[data-parent="PackageIntervention"][data-key="intervention_big"]').hasClass('selected') && jQuery('[data-parent="PackageRehab"][data-key="1"]').hasClass('selected')) ||
                    (jQuery('[data-parent="PackageSpecialist"][data-key="standard"]').hasClass('selected') && jQuery('[data-parent="PackageIntervention"][data-key="intervention_medium"]').hasClass('selected') && jQuery('[data-parent="PreventiveCheckup"][data-key="1"]').hasClass('selected')) ||
                    (jQuery('[data-parent="PackageSpecialist"][data-key="standard"]').hasClass('selected') && jQuery('[data-parent="PackageIntervention"][data-key="intervention_big"]').hasClass('selected') && jQuery('[data-parent="PreventiveCheckup"][data-key="1"]').hasClass('selected')) ||
                    (jQuery('[data-parent="PackageSpecialist"][data-key="standard"]').hasClass('selected') && jQuery('[data-parent="PackageRehab"][data-key="1"]').hasClass('selected') && jQuery('[data-parent="PreventiveCheckup"][data-key="1"]').hasClass('selected')) ||
                    (jQuery('[data-parent="PackageSpecialist"][data-key="nadstandard"]').hasClass('selected'));

                $('[name="geneplanet-valid"]').val(showGeneplanetQuestion ? 1 : 0);

                if (showGeneplanetQuestion) {
                    $('.geneplanet-question').removeClass('d-none');
                } else {
                    $('.geneplanet-question').addClass('d-none');

                    $('[name="geneplanet-selection"]').prop('checked', false);

                    $('.geneplanet-question .checked').removeClass('checked');
                }
            });
        })();

        (function () {
            if ($('.linked-item').hasClass('selected')) {
                
                let linkedItems= $($('.linked-item').get(0)).data('linked');

                let linkedArr = linkedItems.split(',');

                for (const item of linkedArr) {
                    let $t = $('.paket-card[data-key="'+item+'"]');
                    acceptableArr.push($t.data('parent'));

                    if (!$t.hasClass('selected')) {
                        // $t.click();
                        $t.trigger('click');
                    }
                    $t.closest('.kritje-collapsible').collapse('show');
                }
            }
        })();

        //Controls what should happen whenever a "paket" is selected
        $('#izbira-zavarovanja-wrapper').on('custom', function (e, kritje, paket) {
            let $that = $(this),
                $finalizeBtn = $('#finalize-selection');

            //Generate array of selected "kritja"
            let selectedKritja = $that.data('selected-kritja');
            if (selectedKritja === undefined) {
                selectedKritja = [];
            }

            //If paket was unselected, remove associated kritje from array
            if (paket === '') {
                selectedKritja = selectedKritja.filter(item => item !== kritje);
            } else {
                //Add it to the array only if it is not yet present
                if (selectedKritja.indexOf(kritje) < 0) {
                    selectedKritja.push(kritje);
                }
            }

            //Push data back to the DOM element
            $that.data('selected-kritja', selectedKritja);

            let hasSelection = $('.is-selected');

            let genePlanetValidate = true;

            if (!$('.geneplanet-question').hasClass('d-none')) {
                if (!$('[name="geneplanet-selection"]').is(':checked')) {
                    genePlanetValidate = false;
                }
            }

            if (
                hasSelection.length > 0 && 
                $('.paket-selection-option.selected').length >= $('#selected-kritje-count').val() &&
                $('input[name="web-sus-pref-q1"]').is(':checked') &&
                genePlanetValidate
            ) {
                $finalizeBtn.removeClass('disabled');
            } else {
                $finalizeBtn.addClass('disabled');
            }
        });

        $('input[name="web-sus-pref-q1"]').on('change', function() {
            $izbiraWrapper = $('#izbira-zavarovanja-wrapper');

            $izbiraWrapper.trigger('custom');

            $('input[name="web-sus-pref-q1-val"]').val($(this).val());
        });

        $('[name="geneplanet-selection"]').on('change', function() {
            $izbiraWrapper.trigger('custom');
        });

        //Controls how the card loses it's shadow when expanded
        $('.kritja-accordion .kritje-collapsible').on('show.bs.collapse hide.bs.collapse', function () {
            $(this).closest('.card.kritje').toggleClass('expanded');
        });
/* 
        $('#age-form').on('change', function () {
            //showLoaderPopup();

            $('#izbira-zavarovanja-wrapper').removeClass('disabled');
            
            //fetchPrices();
     
        }).on('submit', function (e) {
            e.preventDefault();
        }); */


        //Elementor specific age form
        $('#age-form-elementor').on('change', function () {
            let age = $(this).find('#age').val(),
                ageString = $(this).find('option:selected').html();

            let data = {
                'age': age,
            };

            ajaxHelper(data, 'set_age_ajax').then((response) => {
                location.reload();
            }, (response) => {

            });
        }).on('submit', function (e) {
            e.preventDefault();
        });


        //FAQ Search
        (function () {
            let $searchBox = $('#faq-search'),
                $fWrapper = $('#faq-wrapper'),
                $noResults= $('#no-results');

            if ($fWrapper.length > 0) {
                var $answers = $fWrapper.find('article.faq'),
                    $catHeadings = $fWrapper.find('.cat-title');
            }

            let data = [];

            let showResults = function (ids) {
                if (!ids) return;
                //ids is an array of active faq items (their ids)




                $catHeadings.hide();

                for (let answer of $answers) {
                    let $a = $(answer),
                        id = parseInt($a.attr('data-cid'));

                    if (ids.indexOf(id) < 0) {
                        $a.hide();
                    } else {
                        $a.show();
                    }
                }

            };


            let resetSearch = function () {
                $noResults.hide();
                $answers.show();
                $catHeadings.show();
            };



            if ($answers && $answers.length > 0) {
                for (let answer of $answers) {
                    let $answer = $(answer),
                        title = $answer.find('.entry-title').text(),
                        id = $answer.attr('data-cid'),
                        content = $answer.find('.entry-content').text();

                    let o = {
                        'title': title,
                        'postID': id,
                        'content': content
                    };

                    data.push(o);
                }
            }



            let options = {
                id: "postID",
                shouldSort: true,
                findAllMatches: true,
                includeMatches: true,
                threshold: 0.6,
                location: 0,
                distance: 100,
                maxPatternLength: 32,
                minMatchCharLength: 2,
                keys: [
                    "title",
                    "content"
                ]
            };

            let fuse = new Fuse(data, options);

            $searchBox.on('keyup', debounce(function () {
                let searchString = $searchBox.val();

                if (searchString === '') {
                    resetSearch();
                    $fWrapper.removeClass('active-search');
                } else {
                    let results = fuse.search(searchString),
                        ids = [];

                    if (results.length < 1) {
                        $noResults.show();
                    }

                    for (let result of results) {
                        ids.push(parseInt(result.item.postID));
                    }
                    showResults(ids);
                    $fWrapper.addClass('active-search');
                }

            }, 500));

            $('#faq-search-form').on('submit', function(e) {
                e.preventDefault();
            });
        })();

        (function () {
            $('#konfigurator-form input[type="radio"]').on('click', function() {
                let that = $(this);
                that.closest('.form-group').find('.form-check').removeClass('checked');
                that.closest('.form-check').addClass('checked');
            });

            $('#konfigurator-form input[type="radio"]:checked').closest('.form-check').addClass('checked');
        })();

        (function () {
            $('.page-template-izbira-zavarovanja input[type="radio"]').on('click', function() {
                let that = $(this);
                that.closest('.form-group').find('.form-check').removeClass('checked');
                that.closest('.form-check').addClass('checked');
            });

            $('.page-template-izbira-zavarovanja input[type="radio"]:checked').closest('.form-check').addClass('checked');
        })();

        (function () {
            let $kombinacijeCarousel = $('.kombinacije-carousel .owl-carousel');

            let $numberOfSlides = $('.kombinacije-carousel  .owl-carousel article').length;

            let isMobile = window.matchMedia("(max-width: 768px)").matches;

            if ($kombinacijeCarousel.length > 0) {
                let sliderSettings = {
                    /* center: true,
                    items:6,
                    loop:true,
                    margin:50,
                    autoWidth:true, */
                    responsive: {
                        0: {
                            center: true,
                            items:1,
                            loop:true,
                            margin:15,
                            autoWidth:true
                        },
                        1200: {
                            center: $numberOfSlides > 4,
                            items: Math.min(4, $numberOfSlides),
                            loop: $numberOfSlides > 4,
                            margin:50,
                            autoWidth:true,
                        }
                    }
                };

                if (!isMobile && $numberOfSlides === 4) {
                    jQuery('.kombinacije-carousel').addClass('d-flex').addClass('justify-content-center');

                    jQuery('.kombinacije-prev').addClass('d-none');
                    jQuery('.kombinacije-next').addClass('d-none');
                }

                if ($numberOfSlides <= 4 && !isMobile) {
                    sliderSettings.mouseDrag = false;
                    sliderSettings.touchDrag = false;
                }


                $kombinacijeCarousel.on('refreshed.owl.carousel', function () {

                    let $center = $kombinacijeCarousel.find('.owl-item.center');
                    $center.addClass('item-active');
                    $center.prev().addClass('item-active');
                    $center.next().addClass('item-active');
                });

                $kombinacijeCarousel.owlCarousel(sliderSettings);

                $kombinacijeCarousel.trigger('refresh.owl.carousel');


                let idx, $item;
                $kombinacijeCarousel.on('translate.owl.carousel', function(e){
                    idx = e.item.index;
                    $item = $kombinacijeCarousel.find('.owl-item');
                    $item.removeClass('item-active');
                    $item.eq(idx).addClass('item-active');
                    $item.eq(idx-1).addClass('item-active');
                    $item.eq(idx+1).addClass('item-active');
                });

                $('.kombinacije-next').on('click', function() {
                    $kombinacijeCarousel.trigger('next.owl.carousel');
                });

                $('.kombinacije-prev').on('click', function() {
                    $kombinacijeCarousel.trigger('prev.owl.carousel');
                });

                
                    $('.kombinacije-carousel .owl-item').each(function() {
                        $(this).addClass('item-active');
                    });
                
            }


        })();

        (function () {
            let $mnenjaCarousel = $('.mnenja-carousel  .owl-carousel');

            if ($mnenjaCarousel.length > 0) {

                $mnenjaCarousel.on('refreshed.owl.carousel', function () {

                    let $center = $mnenjaCarousel.find('.owl-item.center');
                    $center.addClass('item-active');
                    $center.prev().addClass('item-active');
                    $center.next().addClass('item-active');
                });

                $mnenjaCarousel.owlCarousel({
                    center: true,
                    items:5,
                    loop:true,
                    margin:50,
                    autoWidth:true,
                    responsive: {
                        0: {
                            center: true,
                            items:1,
                            loop:true,
                            margin:15,
                            autoWidth:true
                        },
                        1200: {
                            center: true,
                            items:5,
                            loop:true,
                            margin:50,
                            autoWidth:true,
                        }
                    }
                });



                let idx, $item;
                $mnenjaCarousel.on('translate.owl.carousel', function(e){
                    idx = e.item.index;
                    $item = $mnenjaCarousel.find('.owl-item');
                    $item.removeClass('item-active');
                    $item.eq(idx).addClass('item-active');
                    $item.eq(idx-1).addClass('item-active');
                    $item.eq(idx+1).addClass('item-active');
                });

                $('.mnenja-next').on('click', function() {
                    $mnenjaCarousel.trigger('next.owl.carousel');
                });

                $('.mnenja-prev').on('click', function() {
                    $mnenjaCarousel.trigger('prev.owl.carousel');
                });
            }
        })();


        (function () {
            $('.sub-menu-toggle').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                // $(this).closest('.nav-link').attr("aria-expanded","true");

                $(this).closest('.nav-link').attr('aria-expanded', function(index, attr){

                    if (!attr || attr == 'false') {
                        return true;
                    } else {
                        return false;
                    }
                });



                $(this).closest('.menu-item').toggleClass('show').children('.dropdown-menu').toggleClass('show');
            });
        })();


        $('#discount').on('change', function () {
            let $that = $(this),
                val = $that.val(),
                $noticeWrapper = $that.siblings('.notice-wrapper');

            let notice = '';

            $that.attr('disabled', true);

            if (val !== '') {
                let data = {
                    'code': val,
                };

                ajaxHelper(data, 'verify_discount').then((response) => {
                    $that.attr('disabled', false);

                    if(response.success === 'age_not_valid') {
                        notice = 'Promocijska koda ni veljavna za izbrano starostno skupino';
                    } else if (response.success !== true) {
                        notice = 'Prišlo je do napake';
                    } else {
                        if (response.data.valid !== true) {
                            notice = 'Koda "'+val+'" ni pravilna';
                            $that.val('');
                        } else {
                            notice = 'Koda, ki ste jo vnesli, je pravilna. <br>Popust s promocijsko kodo je izračunan glede na osnovno ceno izbranih zavarovalnih kritij in bo prikazan v naslednjem koraku.';
                        }
                    }


                    $noticeWrapper.html(notice);
                }, (response) => {
                    console.log(response);
                });
            }

        });





        $('.masonry').masonry({
            columnWidth: '.grid-sizer',
            itemSelector: '.post-item',
            gutter: '.gutter-sizer',
            percentPosition: true
        });


        (function () {
            const $miniCart = $('#mini-cart'),
                  $body = $('body');

            $('#mini-cart-trigger').on('click', function (e) {
                e.preventDefault();
                let $that = $(this);

                $that.toggleClass('active');
                $miniCart.toggleClass('active');
                $body.toggleClass('prevent-scroll');
            });
        })();


        (function () {
            let sTrigger = $('#search-trigger'),
                sWrapper = $('#search-wrapper'),
                $body = $('body'),
                $overlay = $('.overlay'),
                $close = sWrapper.find('.close');

            sWrapper.open = false;
            sWrapper.toggler = function(){
                this.toggleClass('active');
                $body.toggleClass('overlay-active').toggleClass('prevent-scroll');
                sWrapper.open = !sWrapper.open;
            };
            sWrapper.closer = function() {
                this.removeClass('active');
                $body.removeClass('overlay-active').removeClass('prevent-scroll');
                sWrapper.open = false;
            };

            sTrigger.on('click', function (e) {
               e.preventDefault();
               sWrapper.toggler();
            });



            $close.add($overlay).on('click', function (e) {
                e.preventDefault();
               sWrapper.closer();
            });
        })();


        (function () {
            let $searchWrapper = $('#search-wrapper'),
                $searchForm = $searchWrapper.find('#searchform'),
                $searchInput = $searchForm.find('#s');

            $searchInput.on('change', function () {
                console.log('changed');
            });
        })();








        function setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }



        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('.m-wrapper-outer'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
        });



        /*
        ******************************************************************************************************
            Tables
        ******************************************************************************************************
        */

        $('#content table').each(function(){
            $(this).addClass('table');
        });

        (function () {
            let $table  = $('.table');
            if($table.length > 0){
                $table.each(function(i, table) {
                    $(table).wrap('<div class="table-responsive"></div>');
                });
            }
        })();



        //Extends jQuery with .animateCss() method (used for the language switcher among other things)
        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function() {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });


        (function () {
            // Javascript to enable link to tab
            var url = document.location.toString();
            if (url.match('#')) {
                $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
            }

            // Change hash for page-reload
            $('.nav-tabs a').on('shown.bs.tab', function (e) {
                history.pushState(null,null,e.target.hash);
            })
        })();



        initAutocomplete = function() {

            // Create the autocomplete object, restricting the search predictions to
            // geographical location types.
            var input = document.getElementById('locationInput');

            if (input === null) {
                return;
            }

            autocomplete = new google.maps.places.Autocomplete(input, {types: ['geocode']});
            autocomplete.setComponentRestrictions({'country': 'si'});

            // Avoid paying for data that you don't need by restricting the set of
            // place fields that are returned to just the address components.
            autocomplete.setFields(['geometry']);

            // When the user selects an address from the drop-down, populate the
            // address fields in the form.
            autocomplete.addListener('place_changed', fillInAddress);
        }();

        function fillInAddress() {
            // Get the place details from the autocomplete object.
            var place = autocomplete.getPlace();

            document.getElementById('locationLat').value = place.geometry.location.lat();
            document.getElementById('locationLng').value = place.geometry.location.lng();
        }

        $('#ponudniki-search').on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });       

        jQuery('#zelo-mi-je-pomembno').prop('checked', false);

        $('input[type="radio"].conditional-check').on('click', function() {

            $('input[type="radio"].conditional-check').each(function() {
                let target = $(this).data('target');
                console.log($(this).is(':checked'));
                if ($(this).is(':checked')) {
                    $(target).removeClass('d-none');
                } else {
                    $(target).addClass('d-none');
                }
            });
        });
    });

    let isMobile = window.matchMedia("(max-width: 768px)");

    if (!isMobile.matches) {
        $('#mini-cart').css('top', ($('#wrapper-navbar').height()));
    }

    function showLoaderPopup() {
        $('.loader-popup').removeClass('d-none');
        $('body').addClass('overflow-hidden');
    }

    function hideLoaderPopup() {
        $('.loader-popup').addClass('d-none');
        $('body').removeClass('overflow-hidden');
    }

    $('.conf-submit-alt').on('click', function() {
        $('#konfigurator-form').trigger('submit');
    })

    function fixPaketColWidth() {
        $('.solo-column').removeClass('solo-column');

        $('.paket-row').each(function() {
            let $numOfAllCards = $(this).find('.paket-selection-option').length;
            let $numOfEnabledCards = $(this).find('.paket-selection-option.enabled').length;
  
            if ($numOfAllCards - $numOfEnabledCards === 1 || $numOfAllCards === 1) {
                $(this).find('.paket-col').each(function() {
                    if ($(this).find('.paket-selection-option').hasClass('enabled')) {
                        $(this).addClass('solo-column');
                    }
                });
            }
        });
    }

    function fixFeatureStatColWidth() {
        $('.solo-feature-column').removeClass('solo-feature-column');

        $('.feature-stat-row').each(function() {
            let $numOfAllCols = $(this).find('.feature-stat-col').length;
            let $numOfEnabledCols = $(this).find('.feature-stat-col:not(.d-none)').length;
       
            if ($numOfAllCols - $numOfEnabledCols === 1 || $numOfAllCols === 1) {
                $(this).find('.feature-stat-col').each(function() {
                    if (!$(this).hasClass('d-none')) {
                        $(this).addClass('solo-feature-column');
                    }
                });
            }
        });
    }

    $('.paket-card.paket-selection-option').on('click', function() {
        syncKritjaWithCart();

    });

    function syncKritjaWithCart() {
        setTimeout(function() {
            let constructedHTML = '';

            let isNadstandardSelected = jQuery('.paket-card[data-key="nadstandard"]').hasClass('selected');

            $premiumText = 'Premija (vključuje 8,5 % DPZP in 10 % spletni popust)';            
            $taxKritjeCardText = 'vključuje 8,5 % DPZP in 10 % spletni popust';

            if (isNadstandardSelected) {
                $taxText = `Mesečna premija (vključuje 8,5 % DPZP in 15 % spletni popust):`;
                $premiumText = 'Premija (vključuje 8,5 % DPZP in 15 % spletni popust)';
                $taxKritjeCardText = 'vključuje 8,5 % DPZP in 15 % spletni popust';
            }

            $('.paket-card.paket-selection-option.selected').each(function() {
                let $kritjeName = $(this).find('.kritje-title').text();
                let $packageName = $(this).find('.paket-title').html();
                let $packageAgeGroup = $(this).find('.age-range-wrapper > span').text();
                let $taxText = `Mesečna premija (vključuje 8,5 % DPZP in 10 % spletni popust):`;
                let $price = $(this).find('.price').text();

                constructedHTML += `
                    <div>
                        <div class="kritje-name">${ $kritjeName }</div>
                            <div class="package-name">
                                ${ $packageName }
                            </div>
                        <div class="info d-block small font-weight-normal text-light lh-1 mt-2">
                            <span class="d-inline-block">
                                Starostna skupina:                                                 
                            </span>
                            <span class="d-inline-block">${ $packageAgeGroup }</span>
                        </div>
                            <div class="d-flex justify-content-between align-items-center mt-1">
                                <span class="d-block small font-weight-normal text-light lh-1">${ $taxText }</span>
                            <span class="d-block font-weight-medium lh-1 white-space-nowrap">${ $price }</span>
                        </div>
                    </div>
                `;
            });

            $('.package-selection-cart-wrapper').html('');
            $('.package-selection-cart-wrapper').html(constructedHTML);

            $('.premium-text').text($premiumText);
            $('.card-kritje-ddv').text($taxKritjeCardText);


            setDisabledKritjeOptions();

        }, 500);

        jQuery('.nadstandard-popup .nadstandard-popup-close-icon, .nadstandard-popup .btn-close').on('click', function(e) {
            e.preventDefault();
            
            hideNadstandardPopup();
        });

        jQuery('.nadstandard-popup-open-button').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            showNadstandardPopup(
                localize.texts.nadstandard_pupup_klik.zgornje_besedilo,
                localize.texts.nadstandard_pupup_klik.spodnje_besedilo
            );
        });
/* 
        fixPaketColWidth();
        fixFeatureStatColWidth(); */
    }

    $('#konfigurator-form').on('submit', function() {
        showLoaderPopup();
    });

    $('input').on('keyup', function() {
        if ($(this).val().length !== 0) {
            $(this).siblings('.sr-only').addClass('has-value');
        } else {
            $(this).siblings('.sr-only').removeClass('has-value');
        }
    });

    $('input').each(function() {
        if ($(this).val().length !== 0) {
            $(this).siblings('.sr-only').addClass('has-value');
        } else {
            $(this).siblings('.sr-only').removeClass('has-value');
        }
    });

    $('.datefield').on('change', function() {
        if ($(this).val() !== '') {
            $(this).siblings('.sr-only').addClass('has-value');
        } else {
            $(this).siblings('.sr-only').removeClass('has-value');
        }
    });

    $('#kritje-form .paket-selection-option').on('click', function(e) {            
        e.stopPropagation();

        fetchCartPreviewData();
    });
    
    jQuery('.kritje-count-select .btn-kritje-count-select').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        let dataIndex = jQuery(this).attr('data-kritje-count-selection');

        jQuery('.kritje-count-text-wrapper .kritje-count-text').each(function() {
            if (jQuery(this).attr('data-text') !== dataIndex) {
                jQuery(this).addClass('d-none');
            } else {
                jQuery(this).removeClass('d-none');
            }
        });

        jQuery('.kritje-count-select .btn-kritje-count-select').each(function() {
            jQuery(this).removeClass('selected');
        });

        jQuery(this).addClass('selected');

        jQuery('.paket-selection-option.selected').each(function() {
            jQuery(this).trigger('click')
        });

        jQuery('#selected-kritje-count').val(jQuery(this).attr('data-kritje-count-selection'));

        handleComboCtas();

        fetchPrices();

        setDisabledKritjeOptions();

    });

    jQuery('#age-form #age').on('change', function() {
        
        jQuery('.kritje-count-text-wrapper .kritje-count-text').each(function() {
            jQuery(this).addClass('d-none');
        });

        $('#izbira-zavarovanja-wrapper').removeClass('disabled');

        jQuery('.card.kritje').each(function() {
            jQuery(this).addClass('disabled');
        });

        jQuery('.paket-selection-option.selected').each(function() {
            jQuery(this).trigger('click')
        });

        jQuery('.btn-kritje-count-select.selected').removeClass('selected')
        jQuery('#selected-kritje-count').val('');

        if(jQuery(this).val() == 13) {
            jQuery('.btn-kritje-count-select-4').attr('disabled', true);
            jQuery('.btn-kritje-count-select-4').addClass('disabled');

            jQuery('#heading-PackageIntervention').parent().addClass('d-none');
        } else {
            jQuery('.btn-kritje-count-select-4').attr('disabled', false);
            jQuery('.btn-kritje-count-select-4').removeClass('disabled');

            jQuery('#heading-PackageIntervention').parent().removeClass('d-none');
        }
    });

    setInitialIzbiraZavarovanjaValues();

    function showNadstandardPopup(firstText, secondText) {
        jQuery('.nadstandard-popup .first-text').text(firstText);
        jQuery('.nadstandard-popup .second-text').text(secondText);

        jQuery('.nadstandard-popup').removeClass('d-none');
        jQuery('body').addClass('overflow-hidden');
    }

    function hideNadstandardPopup() {
        jQuery('.nadstandard-popup').addClass('d-none');
        jQuery('body').removeClass('overflow-hidden');
    }

    function handleKritjaCards() {
        let $kritja = $('.kritje.card'),
        $singleKritje;

        if (jQuery('#selected-kritje-count').val() !== '') {
            $kritja.removeClass('disabled');
        }

        $kritja.each(function (i, v) {
            $singleKritje = $(v);

            let count = $singleKritje.find('.enabled').length;

            if (count === 0) {
                $singleKritje.addClass('disabled').find('.collapse').collapse('hide');
            }
        });

        $('.missing-price').each(function() {
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            }
        });


        syncKritjaWithCart();

        fixPaketColWidth();
        fixFeatureStatColWidth();
    }    

    function fetchPrices() {
        showLoaderPopup();

        let age = $('#age-form #age').val(),
        $izbiraZavarovanja = $('#izbira-zavarovanja-wrapper'),
        ageString = $('#age-form').find('option:selected').html(),
        $ageGroup = $('#age-group');

    let data = {
        'age': age,
    };

    if ($ageGroup.length > 0) {
        $ageGroup.val(age);
    }

    ajaxHelper(data, 'fetch_all_prices').then( (response) => {
        //$izbiraZavarovanja.removeClass('disabled');

        $('.missing-price').each(function() {
            $(this).removeClass('missing-price');
        });

        for (const kritje of Object.keys(response)) {

            let paketArr = response[kritje];
            let $kritjeItem;
            let $kritjeHeaderItem;
            let $paketItem;

            paketArr.forEach(paketObj => {
                $kritjeHeaderItem = $('#heading-' + kritje);
                $kritjeItem = $('#' + kritje);

                $paketItem = $kritjeItem.find('.paket-card[data-key="'+paketObj.paket+'"]');
                let price = paketObj.price.toFixed(2).toString();
                price = price.replace('.', ',');


                $paketItem.addClass('has-price').addClass('enabled').removeClass('missing-price').find('.price').text(price + ' EUR');
                $paketItem.find('.age-range-wrapper').text(ageString);

                let card = $(`.paket-card[data-key="${paketObj.paket}"][data-parent="${kritje}"]`);

                let definitionCard = $(`.parent-${kritje}-${paketObj.paket}`);
//TODO: odstrani začasen false
                if (paketObj.price === 0 && false) {
                    $paketItem.removeClass('enabled').addClass('missing-price');

                    $kritjeHeaderItem.find(`paket-${paketObj.paket}`).addClass('missing-price');

                    card.removeClass('enabled');
                    card.removeClass('has-price');
                    card.addClass('missing-price');

                    definitionCard.addClass('d-none');
                } else {
                    card.find('.dynamic-data .price .placeholder').html(paketObj.price)

                    card.addClass('has-price').addClass('enabled').removeClass('missing-price').find('.price').text(price + ' EUR');
                    card.find('.age-range-wrapper').text(ageString);

                    definitionCard.removeClass('d-none');
                }
            });
        }


        handleKritjaCards();

        fixPaketColWidth();
        fixFeatureStatColWidth();

        hideLoaderPopup();
    }, (response) => {
        console.log(response);
    });
    }

    function ajaxHelper(data, action) {
        return new Promise(function (resolve, reject) {
            if ( ! data ) {
                reject('didnt get data object');
            }
            $.ajax({
                url: localize.ajaxurl,
                data: {
                    'action' : action,
                    'data' : data
                },
                type: 'POST',
                success: function( response ) {
                    if ( response ) {
                        resolve(response);
                    } else {
                        reject('Something Went Wrong');
                    }
                }
            });
        });
    }

    function setDisabledKritjeOptions() {
        resetPaketCountDisabled(true);
        
        let selectedKritjeCount = jQuery('#selected-kritje-count').val();

        switch (selectedKritjeCount) {
            case '1':
                handleKritjeCount1Selections();
            break;
            case '2':
                handleKritjeCount2Selections();
            break;
            case '3':
                handleKritjeCount3Selections();
            break;
        }
    }

    function resetPaketCountDisabled(force = false) {
        jQuery('.paket-count-disabled').each(function() {
            if (!jQuery(this).hasClass('paket-count-fixed-disabled') || force) {
                jQuery(this).removeClass('paket-count-disabled');
            }
        });
    }

    function handleKritjeCount1Selections() {
        let pSpecialistiInZdravilakNadstandard = jQuery('.paket-selection-option[data-key="nadstandard"][data-parent="PackageSpecialist"]');

        pSpecialistiInZdravilakNadstandard.addClass('paket-count-disabled');
        pSpecialistiInZdravilakNadstandard.addClass('paket-count-fixed-disabled');

        let numberOfSelected = jQuery('.paket-selection-option.selected').length;

        if (numberOfSelected === 1) {
            jQuery('.paket-selection-option').each(function() {
                if (!jQuery(this).hasClass('selected')) {
                    jQuery(this).addClass('paket-count-disabled');
                }
            });
        } else {
            resetPaketCountDisabled();
        }
    }

    function handleKritjeCount2Selections() {
        let pSpecialistiInZdravilakNadstandard = jQuery('.paket-selection-option[data-key="nadstandard"][data-parent="PackageSpecialist"]');

        pSpecialistiInZdravilakNadstandard.addClass('paket-count-disabled');
        pSpecialistiInZdravilakNadstandard.addClass('paket-count-fixed-disabled');

        let pSpecialistiInZdravilakStandard = jQuery('.paket-selection-option[data-key="standard"][data-parent="PackageSpecialist"]');

        pSpecialistiInZdravilakStandard.addClass('selected');

        jQuery('input[name="kritja[PackageSpecialist]"]').val('standard')

        let numberOfSelected = jQuery('.paket-selection-option.selected').length;

        if (numberOfSelected === 2) {
            jQuery('.paket-selection-option').each(function() {
                if (!jQuery(this).hasClass('selected')) {
                    jQuery(this).addClass('paket-count-disabled');
                }
            });
        } else {
            resetPaketCountDisabled();
        }

        fetchCartPreviewData();
    }

    function handleKritjeCount3Selections() {
        /* if (jQuery('#age-form #age').val() != 13) {
            let pDrugoMnenjekDrugoMnenje = jQuery('.paket-selection-option[data-key="1"][data-parent="PackageSecondOpinion"]');

            pDrugoMnenjekDrugoMnenje.addClass('paket-count-disabled');
            pDrugoMnenjekDrugoMnenje.addClass('paket-count-fixed-disabled');
        } */

        if (jQuery('#age-form #age').val() == 13) {
            let pSpecialistiInZdravilakNadstandard = jQuery('.paket-selection-option[data-key="nadstandard"][data-parent="PackageSpecialist"]');

            pSpecialistiInZdravilakNadstandard.addClass('paket-count-disabled');
            pSpecialistiInZdravilakNadstandard.addClass('paket-count-fixed-disabled');   
        }
    }
    
    let ajaxFormUpdateTimeout = null;

    function fetchCartPreviewData() {
        clearTimeout(ajaxFormUpdateTimeout);

        ajaxFormUpdateTimeout = setTimeout(function() {

            showLoaderPopup();

            let entities = [];
            let age = $('#age-group').val();

            jQuery('input[type="hidden"][name*="kritja"]').each(function() {
                if ($(this).val()) {
                    //kritja[PackageIntervention]
                    let kritje = $(this).attr('name').replace('kritja[', '').replace(']', '');
                    let package = $(this).val();

                    entities.push({
                        kritje: kritje,
                        package: package
                    })
                }
            });

            

            $.ajax({
                url: localize.ajaxurl,
                data: {
                    action: 'fetch_cart_preview_data',
                    kritja: entities,
                    age: age
                },
                method: 'POST',
                success: function(response) {
                    $('.price-preview-text').html(response.price);
                    $('.package-preview-data').html(response.kritja_html);
                    $('.discount-preview-text').html(response.discount);
                    $('.premium-text').html(response.premium_text);

                    if (response.number_of_selected === 1) {
                        $('.discount-preview-area').removeClass('d-flex');
                        $('.discount-preview-area').addClass('d-none');
                    } else {
                        $('.discount-preview-area').addClass('d-flex');
                        $('.discount-preview-area').removeClass('d-none');
                    }

                    if (response.number_of_selected === 0) {
                        $('.cart-data-area-invisible').removeClass('d-none');
                        $('.cart-data-area-visible').addClass('d-none');

                        $('.price-preview-text-secondary-wrapper').addClass('d-none');

                        $('.price-preview-text').html('00,00 €');
                    } else {
                        $('.cart-data-area-invisible').addClass('d-none');
                        $('.cart-data-area-visible').removeClass('d-none');

                        $('.price-preview-text-secondary-wrapper').removeClass('d-none');
                    }
                    
                    hideLoaderPopup();
                }
            });

        }, 600);
    }

    function setInitialIzbiraZavarovanjaValues() {
        if (jQuery('#age-form #age').val() == 13) {
            jQuery('.btn-kritje-count-select[data-kritje-count-selection="4"]').addClass('disabled');
        }

        if (jQuery('#selected-kritje-count').val()) {
            let selectedKritjeCount = jQuery('#selected-kritje-count').val();

            jQuery('.btn-kritje-count-select').get(selectedKritjeCount - 1).classList.add('selected');
            jQuery(`.kritje-count-text[data-text="${ selectedKritjeCount }"]`).removeClass('d-none');


            if (selectedKritjeCount == 1 || selectedKritjeCount == 2) {
                jQuery('.paket-selection-option[data-key="nadstandard"][data-parent="PackageSpecialist"]')
                    .addClass('paket-count-fixed-disabled')
                    .addClass('paket-count-disabled');

                jQuery('.paket-selection-option').each(function() {
                    if (!jQuery(this).hasClass('paket-count-fixed-disabled') && !jQuery(this).hasClass('selected')) {
                        jQuery(this).addClass('paket-count-disabled');
                    }
                });
            }

            if (selectedKritjeCount == 3) {
                handleKritjeCount3Selections();
            }

            handleComboCtas();
        }
    }

    function handleComboCtas() {
        if (jQuery('#selected-kritje-count').val() == 4) {
            jQuery('.card.kritje .combo-cta').each(function() {
                jQuery(this).addClass('d-none');
            });
        } else {
            jQuery('.card.kritje .combo-cta').each(function() {
                jQuery(this).removeClass('d-none');
            });
        }
    }
    
})( jQuery );


